export default {
    topics: [
        {
            title: ' Samples ',
            href: 'p-14.html',
            attributes: { 'data-id': 'p-14' },
            menu: { hasChildren: false },
            tocID: 'p-14-d66e70',
            topics: [],
        },
        {
            title: 'xtk',
            href: 's-xtk-abstractForm.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e78',
            next: 'tocId-d66e78',
        },
        {
            title: 'nl',
            href: 's-nl-monitoring.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e1939',
            next: 'tocId-d66e1939',
        },
        {
            title: 'ncm',
            href: 's-ncm-content.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e1988',
            next: 'tocId-d66e1988',
        },
        {
            title: 'nms',
            href: 's-nms-address.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e2102',
            next: 'tocId-d66e2102',
        },
    ],
};

